module.exports = __webpack_public_path__ + "src/img/close-red.95bee79f.svg";